// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {},
  "className": "Ckeditor::Asset",
  "collectionKey": "ckeditor/assets",
  "collectionName": "editor_pilots",
  "i18nKey": "ckeditor/asset",
  "camelizedLower": "ckeditor::Asset",
  "name": "EditorPilot",
  "nameDasherized": "editor-pilot",
  "pluralName": "ckeditor_assets",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "storage_data_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "storage_data_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "storage_data_attachment"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "data_content_type",
      "column": {
        "default": null,
        "name": "data_content_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "data_file_name",
      "column": {
        "default": null,
        "name": "data_file_name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "data_file_size",
      "column": {
        "default": null,
        "name": "data_file_size",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "data_fingerprint",
      "column": {
        "default": null,
        "name": "data_fingerprint",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "height",
      "column": {
        "default": null,
        "name": "height",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "type",
      "column": {
        "default": null,
        "name": "type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "width",
      "column": {
        "default": null,
        "name": "width",
        "null": true,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "asset",
  "primaryKey": "id"
}

/** Frontend model for EditorPilot. */
export default class EditorPilot extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static listAssets(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "list_assets",
        collectionName: "editor_pilots",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static uploadAsset(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "upload_asset",
        collectionName: "editor_pilots",
        type: "collection"
      },
      commandArgs
    ))
  }
}
